
<template>
  <div id="data-list-list-view" class="data-list-container">

    <vs-table ref="table" v-model="selected" search :data="taskofflocations">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

        </div>
        <div class="pb-3 mr-4">
          <vs-button @click="submitFilter()" :disabled="!isFilterTanggal" class="mr-2">Filter</vs-button>
          <flat-pickr v-model="filterTanggal" name="Mulai" v-validate="'required'" :config="config"/>
        </div>

      </div>

      <template slot="thead">
        <vs-th sort-key="tanggal">Hari Tanggal</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.hari }}, {{ tr.tanggal }}</p>
              </vs-td>

              <template v-if="tr.absen">
                <vs-table ref="table" :data="tr.absen" class="subtr">

                    <tbody slot-scope="{data}">
                    <vs-tr :data="abs" :key="indexabs" v-for="(abs, indexabs) in data" :state="abs.classes">
                      <vs-td>
                        <p class="product-name font-medium truncate">{{ abs.nama }}</p>
                      </vs-td>

                      <vs-td>
                        <p class="product-name font-medium truncate">{{ abs.struktur }}</p>
                      </vs-td>
                      
                      <vs-td>
                        <p class="product-name font-medium truncate">{{ abs.keterangan }}</p>
                      </vs-td>
                      
                      <vs-td>
                        <p class="product-name font-medium truncate">{{ abs.mulai }}</p>
                      </vs-td>
                      
                      <vs-td>
                        <p class="product-name font-medium truncate">{{ abs.masuk }}</p>
                      </vs-td>
                    </vs-tr>
                    </tbody>
                  
                </vs-table>
              </template>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>

  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import offlocationModule from '@/stores/rekap/absensi-pegawai.js'

export default {
  components: {
    flatPickr,
  },
  data () {
    return {
      selected: [],
      itemsPerPage: 5,
      isMounted: false,
      publish: false,

      filterMin: 'empty',
      filterMax: 'empty',
      absen_id: 'empty',

      config: {
        mode: 'range'
      },
      filterTanggal: null,

      // Data Sidebar
    }
  },
  computed: {
    isFilterTanggal () {
      return !this.errors.any() && this.filterTanggal
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    taskofflocations () {
      return this.$store.state.offlocation.taskofflocations
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.taskofflocations.length
    }
  },
  methods: {
    getStatus (status) {
      if (status === 'publish') return 'success'
      if (status === 'inherit')  return 'danger'
      return 'success'
    },
    submitFilter() {
      this.$vs.loading()
      this.taskofflocations = []
      let rangeTanggal = this.filterTanggal.split(' to ');
      this.filterMin = rangeTanggal[0]
      this.filterMax = rangeTanggal[1]
      this.loadTask()
      setTimeout(() => {
        this.$vs.loading.close()
        this.taskofflocations = this.$store.state.offlocation.taskofflocations
        this.queriedItems = this.$refs.table ? this.$refs.table.queriedResults.length : this.taskofflocations.length
      }, 3000)
    },
    loadTask() {
      let pilihSet = {
        absen_id : this.absen_id,
        min : this.filterMin,
        max : this.filterMax
      }
      this.$store.dispatch('offlocation/fetchTaskOffLocation', pilihSet)
      .catch(error => { 
        this.$vs.notify({
          color  : 'danger',
          text  : error.message,
        })
      })
      this.$vs.loading.close()
    },
  },
  created () {
    if (!offlocationModule.isRegistered) {
      this.$store.registerModule('offlocation', offlocationModule)
      offlocationModule.isRegistered = true
    }
    let pilihSet = {
      absen_id : this.absen_id,
      min : this.filterMin,
      max : this.filterMax
    }
    this.$store.dispatch('offlocation/fetchTaskOffLocation', pilihSet)
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 10px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 10px !important;
          }
      }
    }

    .vs-table.subtr {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead.subtr{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
